export default __webpack_public_path__ + "static/media/ico-pottencial.1c023820.svg";